import {Record, List, Map} from 'immutable';

import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

import Name from '../common/name';
import Image from '../common/image';

export class Conversation extends Record<{
    participants: List<any>;
}>({
    participants: List(),
}) {}

export class KikuChild extends Record<{
    familyLanguage: any;
    numberOfSiblings: any;
    contractSigned: any;
    placement: any;
    lunch: any;
}>({
    familyLanguage: null,
    numberOfSiblings: null,
    contractSigned: null,
    placement: null,
    lunch: null,
}) {}

export interface IChild {
    id: string;
    childId: string;
    institutionId: string;
    groupId: string;
    createdTime: string;
    name: typeof Name.default;
    birthday: string;
    homeAddress: any;
    extraInfo: string;
    allergies: string;
    dietaryRemarks: string;
    language: string;
    nationality: string;
    birthplace: string;
    gender: string; // Deprecated
    genderValue: string; // Deprecated  - Frontend-controlled conversion of the deprecated gender field
    genderId: string;
    startDate: string;
    localStartDate: string;
    endDate: any;
    localEndDate: any;
    localMovingToDate: any;
    email: string;
    loginId: string;
    famlyId: string;
    image: typeof Image.default;
    onApp: boolean;
    tagIds: List<any>;
    tags: List<any>;
    leavingReason: string;
    groupTitle: string;
    isSleeping: boolean;
    naps: List<any>;
    hasVacation: boolean;
    isSick: boolean;
    isAbsent: boolean;
    isTestChild: boolean;
    leaves: List<any>;
    statuses: List<any>;
    checkins: List<any>;
    keyWorkers: List<any>;
    checkedIn: boolean;
    checkinTime: any;
    checkoutType: any;
    checkoutTitle: any;
    pickupTime: any;
    pickupRelationId: any;
    pickupName: any;
    actions: List<any>;
    movingTo: any;
    roles2: List<any>;
    behaviors: BehaviorsCollection;
    childBillPayersBehaviors: BehaviorsCollection;
    conversation: Conversation;
    accidentIncidentReportIds: List<any>;
    kikuChild: KikuChild;
    contacts: List<any>;
    relations: List<any>;
    fetchingContacts: boolean;
    fetchingBillPayers: boolean;
    billPayerIds: List<any>;
    splitConfiguration: any;
    fetchingAccountItems: boolean;
    showAllContacts: boolean;
    accountItemIds: List<any>;
    updating: boolean;
    attending: Map<string, any>;
    statusRegistrations: List<any>;
    isExpected: boolean;
    mealRegistrations: List<any>;
    autoGeneratedId: undefined;
    napsSummary: Array<{startTime: string; duration: number}>;
    migrationBackground: string;
    numberOfHoursPerWeek: string;
    roleInvitationRelationIds: Array<string>;
    deletion: {
        canDelete: boolean;
        canExport: boolean;
    } | null;
}
export class Child extends Record<IChild>({
    id: '',
    childId: '',
    institutionId: '',
    groupId: '',
    createdTime: '',
    name: Name.default,
    birthday: '',
    homeAddress: null,
    extraInfo: '',
    allergies: '',
    dietaryRemarks: '',
    language: '',
    nationality: '',
    birthplace: '',
    gender: '', // Deprecated
    genderValue: '', // Deprecated  - Frontend-controlled conversion of the deprecated gender field
    genderId: '',
    startDate: '',
    localStartDate: '',
    migrationBackground: '',
    numberOfHoursPerWeek: '',
    endDate: null,
    localEndDate: null,
    localMovingToDate: null,
    email: '',
    loginId: '',
    famlyId: '',
    image: Image.default,
    onApp: true,
    tagIds: List(),
    tags: List(),
    leavingReason: '',
    groupTitle: '',
    isSleeping: false,
    naps: List(),
    hasVacation: false,
    isSick: false,
    isAbsent: false,
    isTestChild: false,
    leaves: List(),
    statuses: List(),
    checkins: List(),
    keyWorkers: List(),
    checkedIn: false,
    checkinTime: null,
    checkoutType: null,
    checkoutTitle: null,
    pickupTime: null,
    pickupRelationId: null,
    pickupName: null,
    actions: List(),
    movingTo: null,
    roles2: List(),
    behaviors: new BehaviorsCollection([]),
    childBillPayersBehaviors: new BehaviorsCollection([]),
    conversation: new Conversation(),
    accidentIncidentReportIds: List(),
    kikuChild: new KikuChild(),
    contacts: List(),
    relations: List(),
    fetchingContacts: false,
    fetchingBillPayers: false,
    billPayerIds: List(),
    splitConfiguration: null,
    fetchingAccountItems: false,
    showAllContacts: false,
    accountItemIds: List(),
    updating: false,
    attending: Map(),
    statusRegistrations: List(),
    isExpected: false,
    mealRegistrations: List(),
    autoGeneratedId: undefined,
    napsSummary: [],
    roleInvitationRelationIds: [],
    deletion: null,
}) {}
